import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { Link } from 'react-router-dom';

import '../../App.css';

class Bubbles extends Component{
    render() {
        var bubble1Classes = "step-bubble";
        var bubble2Classes = "step-bubble";
        var bubble3Classes = "step-bubble";
        var bubble4Classes = "step-bubble";
        var line1Classes = "leading-line";
        var line2Classes = "leading-line";
        var line3Classes = "leading-line";
        var description2Classes = "step-description";
        var description3Classes = "step-description";
        var description4Classes = "step-description-extras";
        var link2disabled = "#";
        var link3disabled = "#";
        if(this.props.currentStep == 4) {
            bubble4Classes += " step-bubble-active";
            line3Classes += " leading-line-active";
            description4Classes += " step-description-active";
            link3disabled = "/step3";
        }
        if(this.props.currentStep >= 3) {
            bubble3Classes += " step-bubble-active";
            line2Classes += " leading-line-active";
            description3Classes += " step-description-active";
            link2disabled = "/step2";
            
        }
        if(this.props.currentStep >= 2) {
            bubble2Classes += " step-bubble-active";
            line1Classes += " leading-line-active";
            description2Classes += " step-description-active";
        }
        if(this.props.currentStep >= 1) {
            bubble1Classes += " step-bubble-active";
        }
        return (
        <div>
            <div className="steps-container desktop-only">
            <Link to="/get-started">
                <div className={bubble1Classes}>1</div>
            </Link>
            <div className={line1Classes}></div>
                <Link to={link2disabled}>
                <div className={bubble2Classes}>2</div>
                </Link>
            <div className={line2Classes}></div>
            <Link to={link3disabled}>
                <div className={bubble3Classes}>3</div>
            </Link>
            <div className={line3Classes}></div>
            <span to="/step4">
                <div className={bubble4Classes}>4</div>
            </span>
                <br/>
                <div className="first-step-description first-step-description-active">Upload</div>
                <div className={description2Classes}>Return time/Pricing</div>
                <div className={description3Classes}>Extras</div>
                <div className={description4Classes}>Checkout</div>
                <div className="mobile-step-descriptions hidden">
                <div className="mobile-step-description"><i className="fa fa-upload"></i></div>
                <div className="mobile-step-description"><i className="fa fa-clock-o"></i></div>
                <div className="mobile-step-description"><i className="fa fa-gear"></i></div>
                <div className="mobile-step-description"><i className="fa fa-credit-card"></i></div>
                </div>
            </div>
            <div className="steps-container-mobile mobile-only">
            <div className="step-container">
                <Link to="/get-started">
                <div className={bubble1Classes}>1</div>
                </Link>
                <div className={line1Classes}></div>
                <div className="mobile-step-description2"><i className="fa fa-upload"></i></div>
            </div>
            <div className="step-container">
                <Link to={link2disabled}>
                <div className={bubble2Classes}>2</div>
                </Link>
                <div className={line2Classes}></div>
                <div className="mobile-step-description2"><i className="fa fa-clock-o"></i></div>
            </div>
            <div className="step-container">
                <Link to={link3disabled}>
                <div className={bubble3Classes}>3</div>
                </Link>
                <div className={line3Classes}></div>
                <div className="mobile-step-description2"><i className="fa fa-gear"></i></div>
            </div>
            <div className="step-container">
                <span to="/step4">
                <div className={bubble4Classes}>4</div>
                </span>
                <div className="mobile-step-description2"><i className="fa fa-credit-card"></i></div>
            </div>
            </div>
        </div>
        )
    }
}

export default connect()(Bubbles);
  


// WEBPACK FOOTER //
// ./src/components/steps/Bubbles.js